import { render } from "./EmailSupport.vue?vue&type=template&id=52679e60"
import script from "./EmailSupport.vue?vue&type=script&lang=js"
export * from "./EmailSupport.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__